import { render, staticRenderFns } from "./BaseEditableTextarea.vue?vue&type=template&id=1f459c74&scoped=true&"
import script from "./BaseEditableTextarea.vue?vue&type=script&lang=ts&"
export * from "./BaseEditableTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./BaseEditableTextarea.vue?vue&type=style&index=0&id=1f459c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f459c74",
  null
  
)

export default component.exports